<template>
  <div id="app">
    <de-header></de-header>
    <router-view></router-view>
    <de-footer></de-footer>
  </div>
</template>

<script>
import DeHeader from './components/Header.vue'
import DeFooter from './components/Footer.vue'
import DeCountdown from './components/Countdown.vue'


export default {
  name: 'app',
  components: { DeHeader, DeCountdown, DeFooter },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import './scss/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue